import { render, staticRenderFns } from "./DetailEQuote.vue?vue&type=template&id=442e0d4d&scoped=true&lang=html&"
import script from "./DetailEQuote.vue?vue&type=script&lang=js&"
export * from "./DetailEQuote.vue?vue&type=script&lang=js&"
import style0 from "./DetailEQuote.vue?vue&type=style&index=0&id=442e0d4d&prod&lang=css&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "442e0d4d",
  null
  
)

export default component.exports